<p-table [value]="items()" data-testid="demonstration-agenda-table" *transloco="let t">
  <ng-template #header>
    <tr>
      <th class="w-10" scope="col">
        {{ t('project.steps.rfd.agenda.columns.order') }}
      </th>
      <th class="w-10" scope="col"></th>
      <th class="flex-1" scope="col">
        {{ t('project.steps.rfd.agenda.columns.topic') }}
      </th>
      <th class="w-56 text-center" scope="col">
        {{ t('project.steps.rfd.agenda.columns.duration') }}
      </th>
      <th class="w-12 text-right" scope="col"></th>
    </tr>
  </ng-template>

  <ng-template #body let-item let-index="rowIndex">
    <tr>
      <td class="text-center">
        @if (!readonly() && !locked()) {
          <div class="flex flex-col items-center">
            <i
              (click)="index !== 0 && moveUp.emit(index)"
              (keydown.enter)="index !== 0 && moveUp.emit(index)"
              (keydown.space)="index !== 0 && moveUp.emit(index)"
              [attr.tabindex]="index !== 0 ? 0 : -1"
              role="button"
              [attr.aria-label]="'Move up'"
              [attr.data-testid]="'move-up-' + item.demonstrationAgendaDirectusId"
              class="pi pi-chevron-up cursor-pointer agenda-chevron-icon"
              [class.cursor-not-allowed]="index === 0"
              [class.agenda-chevron-icon-disabled]="index === 0"
            ></i>
            <i
              (click)="index !== items().length - 1 && moveDown.emit(index)"
              (keydown.enter)="index !== items().length - 1 && moveDown.emit(index)"
              (keydown.space)="index !== items().length - 1 && moveDown.emit(index)"
              [attr.tabindex]="index !== items().length - 1 ? 0 : -1"
              role="button"
              [attr.aria-label]="'Move down'"
              [attr.data-testid]="'move-down-' + item.demonstrationAgendaDirectusId"
              class="pi pi-chevron-down cursor-pointer agenda-chevron-icon"
              [class.cursor-not-allowed]="index === items().length - 1"
              [class.agenda-chevron-icon-disabled]="index === items().length - 1"
            ></i>
          </div>
        }
      </td>
      <td class="text-center font-medium">
        {{ index + 1 }}
      </td>
      <td>
        <span class="font-medium">
          {{ item.translations | translateDirectus: 'topic' }}
        </span>
      </td>
      <td class="text-center">
        @if (readonly()) {
          <span class="font-bold">{{ formatDuration(item.duration) }}</span>
        } @else {
          <p-select
            [options]="durationOptions()"
            [ngModel]="item.duration"
            (ngModelChange)="durationChange.emit({item: item, duration: $event})"
            optionLabel="label"
            optionValue="value"
            [disabled]="locked()"
            [pTooltip]="lockedTooltip()"
            appendTo="body"
            class="w-40"
            [attr.data-testid]="'duration-select-' + item.demonstrationAgendaDirectusId"
          />
        }
      </td>
      <td class="text-right">
        <button
          type="button"
          class="agenda-toggle-btn"
          (click)="toggleExpansion(item.demonstrationAgendaDirectusId, $event)"
          [attr.aria-expanded]="isExpanded(item.demonstrationAgendaDirectusId)"
          [attr.aria-label]="item.translations | translateDirectus: 'topic'"
          [attr.data-testid]="'toggle-description-' + item.demonstrationAgendaDirectusId"
        >
          <i
            class="pi text-lg agenda-chevron-icon"
            [class]="{
              'pi-chevron-down': !isExpanded(item.demonstrationAgendaDirectusId),
              'pi-chevron-up': isExpanded(item.demonstrationAgendaDirectusId),
            }"
          ></i>
        </button>
      </td>
    </tr>
    @if (isExpanded(item.demonstrationAgendaDirectusId)) {
      <tr>
        <td class="bg-second-level"></td>
        <td colspan="4" class="px-6 py-3 bg-second-level">
          @let description = item.translations | translateDirectus: 'description';
          @if (description) {
            <p class="m-0">
              {{ description }}
            </p>
          } @else {
            <p class="m-0 text-gray-500 italic">
              {{ t('common.noDataAvailable') }}
            </p>
          }
        </td>
      </tr>
    }
  </ng-template>

  <ng-template #footer>
    <tr class="font-bold bg-gray-50">
      <td class="text-center">
        <div class="total-duration-badge">Σ</div>
      </td>
      <td></td>
      <td class="text-right">
        {{ t('project.steps.rfd.agenda.totalDuration') }}
      </td>
      <td class="text-center">
        {{ formatDuration(totalDuration()) }}
      </td>
      <td></td>
    </tr>
  </ng-template>
</p-table>
